import { useMutation } from '@tanstack/react-query';

import postForgotPassword from 'Api/forgot-password/postForgotPassword';
import postForgotPasswordPayload from 'Domain/forgot-password/model/request/postForgotPasswordRequest';
import { useForgotPasswordState } from 'View/forgot-password/state';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

const usePostForgotPassword = () => {
  const { updateState, state } = useForgotPasswordState();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  const forgotPasswordMutation = useMutation({
    mutationFn: async (formData) => {
      updateState({
        isDisabled: true,
        isResent: formData?.isResent,
        countdown: 60,
        email: formData?.email,
      });

      onShowLoader({ variant: 'loader-primary' });

      const payload = postForgotPasswordPayload(formData);
      const { data } = await postForgotPassword({ payload });

      return {
        isResent: formData?.isResent,
        data,
      };
    },
    onSuccess: (response) => {
      state?.isResent &&
        onOpenToast({
          status: 'success',
          title: 'Email terkirim ulang!',
          description: 'Kami telah mengirim ulang link reset password ke emailmu.',
          duration: 5,
          alwaysShow: false,
        });

      updateState({
        isSent: true,
        ...(response.isResent && { isResent: true }),
      });
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.errors[0]?.message;

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage || 'Failed to send reset password link',
        duration: 3,
        alwaysShow: false,
      });

      updateState({
        isDisabled: false,
        countdown: 0,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });

  return {
    ...forgotPasswordMutation,
    countdown: state?.countdown,
    isDisabled: state?.isDisabled,
  };
};

export default usePostForgotPassword;
